<template>
  <div class="header-sort">
    <span class="header-sort-before" @click="toIndex">首页</span>
    <span v-for="(item,index) in items" :key="index">
      <span class="header-sort-icon el-icon-arrow-right"></span>
      <span
        @click="toPage(item.url, index)"
        :class="index < items.length-1?'header-sort-before':'header-sort-now'"
      >{{item.name}}</span>
    </span>

    <!-- <span 
       v-for="(item,index) in items" 
       :key="'icon'+index"
       v-show="index<item.lenth-1" 
       class="header-sort-icon"
    >></span>-->
  </div>
</template>
<script>
export default {
  name:'HeaderSort',
  components: {},
  props: {
    items:Array //跳转地址对象
  },
  methods:{
     toIndex(){
        this.toPage('/preparing/navigation')
     },
     toPage(url, index){
      console.log('url: ', url);
        const {path} = this.$route
        console.log('path: ', path);
        if (path === url) {
          return
        }
        if(url && index < this.items.length - 1){
          this.$router.push({
            path: url
          })
        }
     }
  }
}
</script>
<style scoped rel="stylesheet/scss" lang="scss">
@import "../../styles/mixin";
.header-sort {
  margin: 20px 0;
  font-size: 12px;
  .header-sort-before {
    color: #808080;
    cursor: pointer;
  }
  .header-sort-icon {
    color: #808080;
    margin: 0 5px;
  }
  .header-sort-now {
    color: #323232;
    cursor: pointer;
  }
}
</style>